import script from "./ExperienceDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceDetails.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceDetails.vue?vue&type=style&index=0&id=7d40a1b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d40a1b0"]])

export default __exports__